import { FlexContainer, FormBuilder } from '@act/storybook';
import { Control, FormState } from 'react-hook-form';
import { ScheduledEventFormType } from '@act/shared/data-transfer-objects';
import { FormConfig } from 'stories/forms/FormBuilder/formBuilder.types';

export type ScheduledEventFormProps = {
  control: Control<ScheduledEventFormType>;
  formState: FormState<ScheduledEventFormType>;
  formConfig: FormConfig<ScheduledEventFormType>;
  disabled?: boolean;
};

/**
 * Shared FormBuilder body for scheduled-event create/edit flows.
 * @param props - React Hook Form control, state, and field config.
 * @returns The scheduled-event form fields.
 */
export const ScheduledEventForm = ({
  control,
  formState,
  formConfig,
  disabled = false,
}: ScheduledEventFormProps) => {
  return (
    <FlexContainer direction="column" padding="16px 0" width="100%">
      <FormBuilder
        config={formConfig}
        control={control}
        formState={formState}
        disabled={disabled}
      />
    </FlexContainer>
  );
};
